import { useState, useEffect } from "react";
import {
  getUsersInfo,
  updateUser,
  createUser,
  deleteUser,
} from "../../../../REDUX/Models/users.Model";
import { useDispatch, useSelector } from "react-redux";
import { setError, signOut } from "../../../../REDUX/Slices/users.Slice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.scss";

export default function Users({ goBack }) {
  const [user_name, setUserName] = useState("");
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [text, setText] = useState("اضافة مستخدم");
  const [users, setUsers] = useState([]);
  const [editId, setEditId] = useState(null);

  const err = useSelector((state) => state.error);
  const dispatch = useDispatch();

  const resetForm = () => {
    setUserName("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setEditId(null);
  };

  const loadUsers = () => {
    getUsersInfo()
      .then((res) => setUsers(res.data.users))
      .catch(() => dispatch(signOut()));
  };

  const handleDelete = (id) => {
    const confirmed = window.confirm("هل انت متأكد من حذف المستخدم ؟");
    if (confirmed) {
      deleteUser(id)
        .then(() => {
          setUsers(users.filter((u) => u.id !== id));
          toast.success("تم حذف المستخدم بنجاح");
        })
        .catch(() => {
          dispatch(signOut());
          toast.error("حدث خطأ أثناء الحذف");
        });
    }
  };

  const handleEdit = (user) => {
    setUserName(user.user_name);
    setFirstName(user.first_name);
    setLastName(user.last_name);
    setEmail(user.email);
    setEditId(user.id);
    setText("تعديل");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = { user_name, first_name, last_name, email, password };
    if (!editId) data.password = password;

    if (editId) {
      updateUser(editId, {
        user_name: data.user_name,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        password: data.password,
      })
        .then(() => {
          resetForm();
          loadUsers();
          toast.success("تم تعديل بيانات المستخدم بنجاح");
        })
        .catch(() => {
          dispatch(setError("فشل التعديل. تأكد من البيانات."));
          toast.error("حدث خطأ أثناء التعديل");
          setTimeout(() => dispatch(setError(null)), 2000);
        });
    } else {
      createUser(data)
        .then(() => {
          resetForm();
          loadUsers();
          toast.success("تم إضافة المستخدم بنجاح");
        })
        .catch(() => {
          dispatch(setError("فشل انشاء المستخدم. تأكد من البيانات."));
          toast.error("حدث خطأ أثناء الإضافة");
          setTimeout(() => dispatch(setError(null)), 2000);
        });
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  return (
    <div className="admin-users">
      <div className="container">
        <header>
          <h2>المستخدمين</h2>
          <p onClick={goBack}>
            اغلاق <i className="fa-light fa-x"></i>
          </p>
        </header>
        <p> عدد المستخدمين {users.length}</p>

        <div className="row">
          <div className="add-user">
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                value={first_name}
                placeholder="الاسم الأول"
                required
                onChange={(e) => setFirstName(e.target.value)}
              />
              <input
                type="text"
                value={last_name}
                placeholder="الاسم الأخير"
                required
                onChange={(e) => setLastName(e.target.value)}
              />
              <input
                type="text"
                value={user_name}
                placeholder="اسم المستخدم"
                required
                onChange={(e) => setUserName(e.target.value)}
              />
              <input
                type="email"
                value={email}
                placeholder="البريد الإلكتروني"
                required
                onChange={(e) => setEmail(e.target.value)}
              />
              {!editId && (
                <input
                  type="password"
                  value={password}
                  placeholder="كلمة المرور"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              )}
              {editId && (
                <button
                  type="button"
                  className="btn cancel"
                  onClick={resetForm}
                >
                  الغاء التعديل
                </button>
              )}
              <button className="btn" type="submit">
                {text}
              </button>
            </form>
            {err && <p>{err}</p>}
          </div>

          <div className="view-users">
            {users.length > 0 ? (
              users.map((user) => (
                <div className="user" key={user.id}>
                  <span onClick={() => handleDelete(user.id)}>
                    <i className="fa-light fa-trash"></i>
                  </span>
                  <span onClick={() => handleEdit(user)}>
                    <i className="fa-light fa-pen"></i>
                  </span>
                  <p>{user.user_name}</p>
                  <p>
                    {user.first_name} {user.last_name}
                  </p>
                  <p>{user.email}</p>
                </div>
              ))
            ) : (
              <p>لا يوجد مستخدمين للعرض</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
